// extracted by css-extract-rspack-plugin
export default {"page":"ZZiJyi6SJMEdMAVR"};